// Voucher print layout: 28 cards per A4 sheet (4 columns × 7 rows). Must match
// the backend VOUCHERS_PER_PAGE (app/vouchers/codegen.py) so a "pages" count in
// the create dialog maps 1:1 to printed sheets.
export const VOUCHERS_PER_PAGE = 28;
export const PRINT_COLS = 4;
export const PRINT_ROWS = 7;
